import container from './container';
import AuthLayout from './auth_layout';

export default container(AuthLayout);
